import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSync, faCheck } from "@fortawesome/free-solid-svg-icons"
import {
	postInventaireFournisseur,
	postInventaireFournisseurReset,
	deleteInventaireFournisseur,
	deleteInventaireFournisseurReset,
} from "../../../store/actions/atelierInventaireActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import CustomModal from "../../basics/interface/CustomModal"

// Édition d'un fournisseur d'inventaire (modal V2). POST/DELETE renvoient la
// liste fraîche → le reducer (atelierInventaire.fournisseurs) met la table à
// jour seul.
const FournisseurModalV2 = ({ fournisseur, onClose }) => {
	const dispatch = useDispatch()
	const postState = useSelector((s) => s.atelierInventaire.postFournisseur)
	const deleteState = useSelector((s) => s.atelierInventaire.deleteFournisseur)
	const isCreate = !fournisseur.id
	const [confirmDelete, setConfirmDelete] = useState(false)
	const [nom, setNom] = useState(fournisseur.nom || "")

	// Fermeture après une sauvegarde OU une suppression réussie.
	useEffect(() => {
		if (!postState.saved && !deleteState.deleted) return
		const t = setTimeout(() => {
			dispatch(postInventaireFournisseurReset())
			dispatch(deleteInventaireFournisseurReset())
			onClose()
		}, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [postState.saved, deleteState.deleted])

	useEffect(
		() => () => {
			dispatch(postInventaireFournisseurReset())
			dispatch(deleteInventaireFournisseurReset())
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	)

	// Quitte le mode "confirmer" si la suppression échoue (fournisseur protégé).
	useEffect(() => {
		if (deleteState.error) setConfirmDelete(false)
	}, [deleteState.error])

	const invalid = !nom.trim()

	const save = () =>
		dispatch(
			postInventaireFournisseur(
				JSON.stringify({ id: fournisseur.id || null, nom: nom.trim() }),
			),
		)
	const remove = () => {
		if (!confirmDelete) {
			setConfirmDelete(true)
			return
		}
		dispatch(
			deleteInventaireFournisseur(JSON.stringify({ id: fournisseur.id })),
		)
	}

	const busy =
		postState.saving ||
		postState.saved ||
		deleteState.deleting ||
		deleteState.deleted

	const buttons = []
	if (!isCreate) {
		buttons.push({
			title: deleteState.deleting ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : confirmDelete ? (
				"Confirmer ?"
			) : (
				"Supprimer"
			),
			styleName: "danger",
			onClick: remove,
			disabled: busy,
		})
	}
	buttons.push({
		title: "Annuler",
		styleName: "secondary",
		onClick: onClose,
		disabled: busy,
	})
	buttons.push({
		title: postState.saving ? (
			<FontAwesomeIcon icon={faSync} spin />
		) : postState.saved ? (
			<FontAwesomeIcon icon={faCheck} />
		) : (
			"Enregistrer"
		),
		styleName: "primary",
		onClick: save,
		disabled: busy || invalid,
	})

	return (
		<CustomModal
			title={isCreate ? "Nouveau fournisseur" : "Éditer le fournisseur"}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={buttons}
		>
			<div style={gs.fieldGroup}>
				<div style={gs.fieldRow}>
					<label style={gs.label}>
						Nom<span style={{ color: COLORS.danger }}> *</span>
					</label>
					<input
						style={gs.input}
						value={nom}
						onChange={(e) => setNom(e.target.value)}
						autoFocus
					/>
				</div>
			</div>
		</CustomModal>
	)
}

export default FournisseurModalV2
